import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { mealAPI } from '../services/api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const MealReader = () => {
  const navigate = useNavigate();
  const [meals, setMeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMeals();
  }, []);

  const loadMeals = async () => {
    try {
      const response = await mealAPI.getAll();
      const mealsData = response.data || [];
      
      setMeals(mealsData);
    } catch (error) {
      console.error('Error loading meals:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMealClick = (meal) => {
    const identifier = meal.slug || meal.id;
    console.log('[MealReader] Click:', meal.name, '→', identifier);
    navigate(`/meal/${identifier}`);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#F9F6F1]">
        <p className="text-[#8B7355]">Yukleniyor...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F9F6F1] py-10 pb-32">
      {/* Header */}
      <div className="max-w-6xl mx-auto px-6 mb-10">
        <div className="text-center mb-8">
          <div className="mb-6">
            <div className="text-6xl text-[#8B7355] mb-4" style={{ fontFamily: '"Traditional Arabic", serif' }}>
              القرآن الكريم
            </div>
          </div>
          <h1 className="text-3xl font-bold text-[#5C4033] mb-3">Yuce Kuran'in Manasi ve Mesaji</h1>
        </div>
      </div>

      {/* Meal Cards Grid - 3 columns */}
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {meals.map((meal, index) => (
            <Card
              key={meal.id}
              onClick={() => handleMealClick(meal)}
              className="bg-white border border-[#E8E8E8] hover:border-[#D5C4A1] hover:shadow-md cursor-pointer p-4"
              style={{
                transition: 'all 0.2s ease'
              }}
            >
              <div className="flex items-center justify-between">
                {/* Left Side - Number and Info */}
                <div className="flex items-start space-x-4 flex-1">
                  {/* Meal Number */}
                  <div className="text-3xl font-light text-[#B8B8B8] w-8">
                    {index + 1}
                  </div>

                  {/* Meal Info */}
                  <div className="flex-1">
                    <h3 className="text-base font-normal text-[#5C4033] mb-1">
                      {meal.name}
                    </h3>
                    <p className="text-sm text-[#8B8B8B]">
                      {meal.duration || `${meal.durationMinutes} dk`}
                    </p>
                  </div>
                </div>

                {/* Right Side - Arabic Name */}
                <div className="text-right">
                  <p className="text-2xl text-[#5C4033]" style={{ fontFamily: '"Traditional Arabic", serif' }}>
                    {meal.nameArabic}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Empty State */}
        {meals.length === 0 && (
          <div className="text-center py-20">
            <p className="text-[#8B7355] text-lg">Henüz meal eklenmemiştir.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MealReader;